export const GraduationHatIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" fill="none">
    <path
      fill="#2A323A"
      d="M7.5 0 .167 4l2.666 1.453v4L7.5 12l4.667-2.547v-4l1.333-.726v4.606h1.333V4L7.5 0Zm4.547 4L7.5 6.48 2.953 4 7.5 1.52 12.047 4Zm-1.214 4.667L7.5 10.48 4.167 8.667V6.18L7.5 8l3.333-1.82v2.487Z"
    />
  </svg>
);
